import { ClientGateway } from "@kex/api";

import type { GetRequisitesMessagesHandler, RequisitesMessage } from "./types";

import { requisitesMessages } from "./messages";

export const getRequisitesCaptionMessages: GetRequisitesMessagesHandler<
  ClientGateway.BankAccountDetailsRussiaModel
> = (_clientType, details) => {
  const messages: RequisitesMessage[] = [];

  if (details.accountNumber) {
    messages.push({
      descriptor: requisitesMessages.accountNumber,
      values: { accountNumber: details.accountNumber },
    });
  }

  if (details.bik) {
    messages.push({
      descriptor: requisitesMessages.bik,
      values: { bikNumber: details.bik },
    });
  }

  return messages;
};

export const getRequisitesDetailsMessages: GetRequisitesMessagesHandler<
  ClientGateway.BankAccountDetailsRussiaModel
> = (clientType, details, name) => {
  const messages: RequisitesMessage[] = [];

  const isIndividual = clientType === "PERSONAL";
  const isCompany = clientType === "COMPANY";

  if (name) {
    messages.push({
      descriptor: requisitesMessages.name,
      values: { name },
    });
  }

  if (isIndividual && details.fullName) {
    messages.push({
      descriptor: requisitesMessages.fullName,
      values: { fullName: details.fullName },
    });
  }

  if (isCompany && details.companyName) {
    messages.push({
      descriptor: requisitesMessages.companyName,
      values: { companyName: details.companyName },
    });
  }

  if (details.bankName) {
    messages.push({
      descriptor: requisitesMessages.bankName,
      values: { bankName: details.bankName },
    });
  }

  if (details.bik) {
    messages.push({
      descriptor: requisitesMessages.bik,
      values: { bikNumber: details.bik },
    });
  }

  if (details.accountNumber) {
    messages.push({
      descriptor: requisitesMessages.accountNumber,
      values: { accountNumber: details.accountNumber },
    });
  }

  if (isCompany && details.correspondentAccount) {
    messages.push({
      descriptor: requisitesMessages.correspondentAccount,
      values: { correspondentAccount: details.correspondentAccount },
    });
  }

  if (isCompany && details.inn) {
    messages.push({
      descriptor: requisitesMessages.inn,
      values: { innNumber: details.inn },
    });
  }

  if (clientType === "COMPANY" && details.kpp) {
    messages.push({
      descriptor: requisitesMessages.kpp,
      values: { kppNumber: details.kpp },
    });
  }

  return messages;
};
